import { CanvasSpatialRenderer } from './canvas-renderer.js';
import type { SpatialRenderer } from './types.js';
import { WebGpuSpatialRenderer } from './webgpu-renderer.js';

export async function createSpatialRenderer(canvas: HTMLCanvasElement): Promise<SpatialRenderer> {
  try {
    return await WebGpuSpatialRenderer.create(canvas);
  } catch {
    return new CanvasSpatialRenderer(canvas);
  }
}
